<template>
  <span class="section-menu" v-click-outside="closeMenu">
    <div class="action" v-on:click="emitDeleteCredsPopup" v-on:focusout="closeMenu">מחיקת חשבון</div>
    <div class="divider"/>
    <div class="action" v-on:click="emitUpdateCredsPopup" v-on:focusout="closeMenu">עריכת שם</div>
  </span>
</template>

<script>
import Segment from '@/Segment';
import ClickOutside from '@/directives/click-outside';
import { mapActions } from 'vuex';
import DeleteCredsPopup from '@/base-components/credentials/credentials-list/DeleteCredsPopup';
import UpdateCredsNamePopup from '@/base-components/credentials/credentials-list/UpdateCredsNamePopup';

export default {
  name: 'CredentialsMenu',
  directives: {
    ClickOutside,
  },
  props: {
    closeMenu: {
      type: Function,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions('credentials', ['updateCredentials', 'deleteCredentials']),
    ...mapActions('modalRootStore', ['openModal']),
    emitDeleteCredsPopup() {
      Segment.trackUserInteraction('SectionMenu_DeleteCredsClicked');
      this.openModal({
        component: DeleteCredsPopup,
        props: { source: this.source },
      });
    },
    emitUpdateCredsPopup() {
      Segment.trackUserInteraction('SectionMenu_UpdateCredsClicked');
      this.openModal({
        component: UpdateCredsNamePopup,
        props: { source: this.source },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';

  .section-menu {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 13px;
    top: 12px;
    border-radius: 1px;
    background-color: $riseup_white;
    box-shadow: 2px 2px 8px 0 $riseup_gray_0;
    width: 125px;

    .action {
      display: flex;
      align-items: center;
      font-family: SimplerPro;
      font-size: 14px;
      padding: 0 8px;
      height: 30px;
      width: 100%;
      cursor: pointer;
      margin: 5px 0;
    }

    .divider {
      height: 1px;
      background: $riseup_gray_0;
    }
  }
</style>
